export enum Flags {
  DischargeQuestions = 'discharge_questions',
  AltcsPending = 'altcs_pending',
  ComparisonForAiSummary = 'comparison_for_ai_summary',
  InboundReferrals = 'inbound_referrals',
  InboundReferralNotifications = 'inbound_referral_notifications',
  InAppNotifications = 'in_app_notifications',
  PushNotifications = 'push_notifications',
  SftpUserSelfService = 'sftp_user_self_service',
  PreferredProviders = 'preferred_providers',
  DischargeChecklist = 'discharge_checklist',
  BenefitVerificationRedesign = 'benefit_verification_redesign',
}
